import React, { useState, useEffect } from "react";
import Box from "../../components/dashboard/Box";
import Bridge from "../../constants/Bridge";
import Cumulative from "../researchData/radcliffStudy/charts/Cumulative";
import AllDemographicGraph from "../researchData/radcliffStudy/charts/AllDemographicGraph";
import Strings from "../../constants/Strings";

const RadcliffStudy = () => {
  const [dashboardCount, setDashboardCount] = useState([]);
  const [loading, setLoading] = useState(false);
  const [getActiveLink, setGetActiveLink] = useState(true);

  useEffect(() => {
    getDashboardData();
  }, []);

  const getDashboardData = () => {
    setLoading(true);
    Bridge.dashboard
      .getDetails()
      .then((result) => {
        if (result.status == "1") {
          let obj = {
            total_radcliff_participants: Number(
              result.total_radcliff_participants
            ),
            active_radcliff_participants: result.active_radcliff_participants,
          };
          setDashboardCount(obj);
          setLoading(false);
        } else {
          setLoading(false);
        }
      })
      .catch(() => {
        setLoading(false);
      });
  };

  return (
    <div>
      <p
        style={{
          position: "relative",
          fontSize: 32,
          fontFamily: "Open Sans",
          fontWeight: "bold",
          color: "#1A4F83",
          textAlign: "start",
        }}
        className="mb-4 mt-4"
      >
        {Strings.radcliffStudy}
      </p>
      <p
        style={{
          position: "relative",
          fontSize: 20,
          fontFamily: "Open Sans",
          fontWeight: "bold",
          color: "#1A4F83",
          textAlign: "start",
        }}
        className="mb-4"
      >
        {Strings.realTimeStatastics}
      </p>
      <div
        style={{
          backgroundColor: "white",
          padding: "2%",
          borderRadius: "19px",
          maxWidth: "100%",
          alignItems: "center",
        }}
      >
        <div className="row" style={{ padding: "2%" }}>
          <p
            style={{
              position: "relative",
              fontSize: 20,
              fontFamily: "Open Sans",
              fontWeight: "bold",
              color: "#1A4F83",
              textAlign: "start",
            }}
            className="mb-4 block-heading"
          >
            Status: Fully enrolled, data in collection and analysis
          </p>
          <div className="col-lg-3">
            <a
              href="/participants/radcliff?filter_status=All"
              style={{
                fontWeight: "regular",
                fontSize: "18",
              }}
              className={`active-links ${getActiveLink ? "active" : ""}`}
            >
              <Box
                title="All Participants"
                count={dashboardCount.total_radcliff_participants || 0}
                getActiveLink={getActiveLink}
              />
            </a>
          </div>
          <div className="col-lg-3">
            <a
              href="/participants/radcliff"
              style={{
                fontWeight: "regular",
                fontSize: "18",
              }}
              className={`active-links ${getActiveLink ? "active" : ""}`}
            >
              <Box
                title="Active Participants"
                count={dashboardCount.active_radcliff_participants || 0}
                getActiveLink={getActiveLink}
              />
            </a>
          </div>
        </div>
        <br />
        <hr style={{ width: "94%", margin: "0 auto" }} />
        <div className="row" style={{ padding: "2%" }}>
          <div className="col-lg-12">
            <Cumulative />
            <AllDemographicGraph />
          </div>
        </div>
      </div>
    </div>
  );
};

export default RadcliffStudy;
